import React from 'react'
import './flipbox.css'

export class FlipBox extends React.Component {
  render(){
    const { front, back, showBack } = this.props
    return (
      <div style={{ height: '100%', position: 'relative', overflow: 'visible' }}>
        <div className={"ac-flipbox" + (showBack ? " hover" : "")} style={{ height: '100%', overflow: 'visible' }}>
          <div style={{ height: '100%', overflow: 'visible' }}>
            <div className="ac-flipbox__front" style={{ color: '#ffffff', display: 'table' }}>
              {front}
            </div>
            <div className="ac-flipbox__back" style={{ color: '#ffffff', display: 'table' }}>
              {back}
            </div>
          </div>
        </div>
      </div>
    )
  }
}


/** WEBPACK FOOTER **
 ** ./src/components/FlipBox.js
 **/